import { Margin } from 'componentregistry';
import { CSSProperties, useMemo } from 'react';

function getMargin(value: number): string {
  return `${value}px`;
}

export type CSSMargin = Pick<
  CSSProperties,
  'margin' | 'marginLeft' | 'marginRight' | 'marginBottom' | 'marginTop'
>;

export default function useMargin(margin?: Margin): CSSMargin {
  return useMemo(() => {
    const style: CSSMargin = {};
    if (typeof margin === 'number') {
      style.margin = getMargin(margin);
    } else if (typeof margin?.all === 'number') {
      style.margin = getMargin(margin.all);
    } else {
      if (typeof margin?.top === 'number') {
        style.marginTop = getMargin(margin.top);
      }
      if (typeof margin?.right === 'number') {
        style.marginRight = getMargin(margin.right);
      }
      if (typeof margin?.bottom === 'number') {
        style.marginBottom = getMargin(margin.bottom);
      }
      if (typeof margin?.left === 'number') {
        style.marginLeft = getMargin(margin.left);
      }
    }
    return style;
  }, [margin]);
}
